module.exports = __webpack_public_path__ + "static/15-angel-7239cd543556b33b1ac2e8f61a1b1c01.jpg";